import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import * as React from 'react';
import TuneIcon from '@mui/icons-material/Tune';
import ClearIcon from '@mui/icons-material/Clear';
import Close from '@mui/icons-material/Close';

import fonts from 'styles/typography.module.css';
import { useClearFilters, useHasUserFilters } from 'pages/Shipments/Containers/utilities';
import {
  ContainerFilter,
  Pickup,
  Holds,
  LastFreeDay,
  PerDiem,
  GatedOut,
  Terminated,
} from './sections';
import { PerDiemLfd } from './sections/PerDiemLfd';

export const MoreFiltersContext = React.createContext<{
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}>({ open: false, setOpen: () => {} });

export const MoreFilters: React.FC = () => {
  const hasFilter = useHasUserFilters();
  const clearFilters = useClearFilters();
  const { open, setOpen } = React.useContext(MoreFiltersContext);

  return (
    <div className="flex">
      {hasFilter && (
        <Button
          classes={{ root: `rounded-full rounded-r-none px-2 text-blue-900 h-full` }}
          variant="outlined"
          color="info"
          style={{ minWidth: 0 }}
          onClick={clearFilters}
        >
          <ClearIcon />
        </Button>
      )}
      <Button
        className={`rounded-full px-7 ${hasFilter && 'rounded-l-none border-l-0 text-blue-900'}`}
        variant="outlined"
        color="info"
        startIcon={<TuneIcon />}
        onClick={() => setOpen(true)}
        style={{ paddingTop: '0.125rem', paddingBottom: '0.125rem' }}
      >
        More filters
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullWidth
        className={fonts.font}
      >
        <DialogTitle className="flex justify-between py-1 items-center border-b border-gray-200">
          More filters
          <IconButton className="rounded-full" color="info" onClick={() => setOpen(false)}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <ContainerFilter />
          <Pickup />
          <Holds />
          <LastFreeDay />
          <PerDiemLfd />
          <GatedOut />
          <PerDiem />
          <Terminated />
        </DialogContent>
        <DialogActions className="border-t border-gray-200">
          <Button
            variant="outlined"
            startIcon={<ClearIcon className="w-4" />}
            color="info"
            onClick={() => {
              clearFilters();
              setOpen(false);
            }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpen(false)}
            className="float-right w-24 mx-5 my-1"
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
MoreFilters.displayName = 'Shipments.Filters.More';
